var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container-sitc" }, [
    _c("div", { staticClass: "filter-container-content" }, [
      _c(
        "div",
        { staticStyle: { padding: "0 40px" } },
        [
          _c("span", { staticClass: "title-h4" }, [
            _vm._v(_vm._s(_vm.$t("equipmentFee.title"))),
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "search-form",
              attrs: {
                model: _vm.form,
                "label-position": "top",
                rules: _vm.rules,
                "label-width": "90px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 14 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("equipmentFee.blNo"),
                            prop: "blNo",
                          },
                        },
                        [
                          _c("el-input", {
                            directives: [{ name: "trim", rawName: "v-trim" }],
                            attrs: {
                              placeholder: _vm.$t("placeholder.blNo"),
                              clearable: "",
                            },
                            model: {
                              value: _vm.form.blNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "blNo", $$v)
                              },
                              expression: "form.blNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      staticStyle: { "margin-top": "28px" },
                      attrs: { span: 6 },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-primary",
                          attrs: { type: "primary" },
                          on: { click: _vm.toSearch },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("button.search")) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-plain-primary",
                          attrs: { type: "success" },
                          on: {
                            click: function ($event) {
                              return _vm.exportHandle()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("equipmentFee.exportExcel")) +
                              "\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-row", { staticClass: "warm-tips" }, [
                _vm._v("\n          " + _vm._s(_vm.$t("equipmentFee.tips_1"))),
                _c("br"),
                _vm._v("\n          " + _vm._s(_vm.$t("equipmentFee.tips_2"))),
                _c("br"),
                _vm._v("\n          " + _vm._s(_vm.$t("equipmentFee.tips_3"))),
                _c("br"),
                _vm._v("\n          " + _vm._s(_vm.$t("equipmentFee.tips_4"))),
                _c("br"),
                _vm._v("\n          " + _vm._s(_vm.$t("equipmentFee.tips_5"))),
                _c("br"),
                _vm._v("\n          " + _vm._s(_vm.$t("equipmentFee.tips_6"))),
                _c("br"),
                _vm._v("\n          " + _vm._s(_vm.$t("equipmentFee.tips_7"))),
                _c("br"),
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("equipmentFee.tips_8")) +
                    "\n        "
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "result-container" }, [
      _vm.showResult
        ? _c(
            "div",
            [
              _c("el-row", { staticStyle: { "padding-bottom": "15px" } }, [
                _vm._v(
                  _vm._s(_vm.$t("equipmentFee.DEMDETFeeTotal")) +
                    _vm._s(_vm.demDetTotal)
                ),
              ]),
              _vm._v(" "),
              _c("el-row", { staticStyle: { "padding-bottom": "15px" } }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("equipmentFee.repairFeeTotal")) +
                    _vm._s(_vm.repairTotal) +
                    " " +
                    _vm._s(_vm.repairCurrency) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "el-tabs",
                {
                  attrs: { type: "border-card" },
                  model: {
                    value: _vm.activeTab,
                    callback: function ($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("equipmentFee.DEMDETFee"),
                        name: "demDetFee",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { "text-align": "center" } },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                id: "demDetData",
                                data: _vm.demDetData,
                                border: "",
                                "cell-style": _vm.columnBackgroundStyle,
                                "summary-method": _vm.getDemDetSummaries,
                                "show-summary": "",
                                size: "small",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: { type: "index", width: "40" },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "containerNo",
                                  label: _vm.$t("equipmentFee.containerNo"),
                                  width: "110",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "containerType",
                                  label: _vm.$t("equipmentFee.containerType"),
                                  width: "60",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "ftNo",
                                  label: _vm.$t("equipmentFee.ftNo"),
                                  width: "105",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-link",
                                            {
                                              staticStyle: {
                                                "font-size": "12px",
                                              },
                                              attrs: { type: "primary" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleFtNo(
                                                    scope.row.ftNo
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(scope.row.ftNo) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  395523417
                                ),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "startMoveDate",
                                  label: _vm.$t("equipmentFee.startDate"),
                                  width: "100",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                !_vm.validateNull(
                                                  scope.row.calculationDate
                                                )
                                                  ? scope.row.calculationDate
                                                  : scope.row.calculationDate2
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2350064746
                                ),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "endMoveDate",
                                  label: _vm.$t("equipmentFee.sysEndDate"),
                                  width: "105",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                !_vm.validateNull(
                                                  scope.row.endMoveDate2
                                                )
                                                  ? scope.row.endMoveDate2
                                                  : scope.row.endMoveDate
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3553475311
                                ),
                              }),
                              _vm._v(" "),
                              _vm.showDemColumn
                                ? _c(
                                    "el-table-column",
                                    { attrs: { label: "DEM" } },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "actFreeDays",
                                          label: _vm.$t(
                                            "equipmentFee.freeDays"
                                          ),
                                          width: "80",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        scope.row
                                                          .combineFlag === 1
                                                          ? "*"
                                                          : scope.row
                                                              .actFreeDays
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          4141423742
                                        ),
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "portName",
                                          label: _vm.$t("equipmentFee.port"),
                                          width: "100",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "days",
                                          label: _vm.$t("equipmentFee.days"),
                                          width: "85",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "overDays",
                                          label: _vm.$t(
                                            "equipmentFee.overDays"
                                          ),
                                          width: "100",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "demAmount",
                                          label: _vm.$t("equipmentFee.amount"),
                                          width: "120",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        !_vm.validateNull(
                                                          scope.row.demAmount
                                                        )
                                                          ? _vm.toMoney(
                                                              scope.row
                                                                .demAmount
                                                            )
                                                          : scope.row.demAmount
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1943097455
                                        ),
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "demAmountCurrency",
                                          label: _vm.$t(
                                            "equipmentFee.currency"
                                          ),
                                          width: "80",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "el-table-column",
                                { attrs: { label: "DET" } },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "actFreeDays2",
                                      label: _vm.$t("equipmentFee.freeDays"),
                                      width: "80",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    scope.row.combineFlag === 1
                                                      ? "*"
                                                      : scope.row.actFreeDays2
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2528252204
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "portName2",
                                      label: _vm.$t("equipmentFee.port"),
                                      width: "100",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "days2",
                                      label: _vm.$t("equipmentFee.days"),
                                      width: "85",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "overDays2",
                                      label: _vm.$t("equipmentFee.overDays"),
                                      width: "100",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "detAmount",
                                      label: _vm.$t("equipmentFee.amount"),
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    !_vm.validateNull(
                                                      scope.row.detAmount
                                                    )
                                                      ? _vm.toMoney(
                                                          scope.row.detAmount
                                                        )
                                                      : scope.row.detAmount
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      932467382
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "detAmountCurrency",
                                      label: _vm.$t("equipmentFee.currency"),
                                      width: "80",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "combineFlag",
                                  "render-header": _vm.renderHeader,
                                  label: "Combine/days",
                                  width: "90",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              style:
                                                scope.row.combineFlag === 1
                                                  ? "font-size:inherit"
                                                  : "font-size: 16px",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row.combineFlag === 1
                                                    ? scope.row.actFreeDays
                                                    : "×"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2997641392
                                ),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "demAmount",
                                  label: _vm.$t("equipmentFee.totalSum"),
                                  width: "140",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                scope.row.demAmountCurrency ===
                                                  scope.row.detAmountCurrency ||
                                                  _vm.validateNull(
                                                    scope.row.demAmountCurrency
                                                  ) ||
                                                  _vm.validateNull(
                                                    scope.row.detAmountCurrency
                                                  )
                                                  ? _vm.toMoney(
                                                      +scope.row.demAmount +
                                                        +scope.row.detAmount
                                                    )
                                                  : ""
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1375160540
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("equipmentFee.repairFee"),
                        name: "repairFee",
                      },
                    },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                id: "repairData",
                                data: _vm.repairData,
                                border: "",
                                "show-summary": "",
                                "summary-method": _vm.getSummaries,
                                size: "small",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: { type: "index", width: "40" },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "targetCurrency",
                                  label: _vm.$t("equipmentFee.info"),
                                  "min-width": "11%",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t("equipmentFee.blNoInner")
                                              ),
                                            },
                                          }),
                                          _vm._v(_vm._s(scope.row.blNo)),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t(
                                                  "equipmentFee.containerNoInner"
                                                )
                                              ),
                                            },
                                          }),
                                          _vm._v(_vm._s(scope.row.containerNo)),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t(
                                                  "equipmentFee.containerTypeInner"
                                                )
                                              ),
                                            },
                                          }),
                                          _vm._v(
                                            _vm._s(scope.row.containerType)
                                          ),
                                          _c("br"),
                                          _vm._v(" "),
                                          scope.row.currency !==
                                            scope.row.targetCurrency &&
                                          !(
                                            scope.row.portCode.substring(
                                              0,
                                              2
                                            ) === "CN" &&
                                            scope.row.currency === "USD"
                                          )
                                            ? _c("div", [
                                                _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.$t(
                                                        "equipmentFee.amountInner"
                                                      )
                                                    ),
                                                  },
                                                }),
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.toMoney(
                                                      scope.row.receivableCharge
                                                    )
                                                  ) +
                                                    " " +
                                                    _vm._s(scope.row.currency)
                                                ),
                                                _c("br"),
                                                _vm._v(" "),
                                                _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.$t(
                                                        "equipmentFee.voyageRateInner"
                                                      )
                                                    ),
                                                  },
                                                }),
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.toMoney(scope.row.rate)
                                                  )
                                                ),
                                                _c("br"),
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t(
                                                  "equipmentFee.amountInner"
                                                )
                                              ),
                                            },
                                          }),
                                          _vm._v(
                                            _vm._s(
                                              scope.row.recvBillFlag == 99
                                                ? "--"
                                                : _vm.toMoney(
                                                    scope.row.repairFee
                                                  ) +
                                                    "  " +
                                                    scope.row.targetCurrency
                                            )
                                          ),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t(
                                                  "equipmentFee.stateInner"
                                                )
                                              ),
                                            },
                                          }),
                                          _vm._v(
                                            _vm._s(
                                              _vm.isCnLang
                                                ? scope.row.recvBillFlag == 0
                                                  ? "未缴费"
                                                  : scope.row.recvBillFlag == 99
                                                  ? "验箱中"
                                                  : "已缴费"
                                                : scope.row.recvBillFlag == 0
                                                ? "Unpaid"
                                                : scope.row.recvBillFlag == 99
                                                ? "Under Inspection"
                                                : "Paid-up"
                                            ) + "\n                "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1237542829
                                ),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "picturesList",
                                  label: _vm.$t("equipmentFee.repairPicture"),
                                  "min-width": "30%",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return !_vm.validateNull(
                                          scope.row.fileName
                                        )
                                          ? [
                                              _vm.validateNull(
                                                scope.row.fileName
                                              )
                                                ? _c("div")
                                                : _c(
                                                    "ul",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        "padding-left": "0px",
                                                        width: "660px",
                                                        "flex-wrap": "wrap",
                                                      },
                                                    },
                                                    _vm._l(
                                                      scope.row.fileName.split(
                                                        ","
                                                      ),
                                                      function (item) {
                                                        return _c(
                                                          "li",
                                                          {
                                                            key: item.index,
                                                            staticStyle: {
                                                              "list-style-type":
                                                                "none",
                                                              "padding-left":
                                                                "10px",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "demo-image__preview",
                                                              },
                                                              [
                                                                _c("el-image", {
                                                                  staticStyle: {
                                                                    width:
                                                                      "60px",
                                                                    height:
                                                                      "60px",
                                                                  },
                                                                  attrs: {
                                                                    src:
                                                                      _vm.minioUrl +
                                                                      item.split(
                                                                        "|"
                                                                      )[1],
                                                                    "preview-src-list":
                                                                      _vm.srcListSwith(
                                                                        scope.row.fileName.split(
                                                                          ","
                                                                        )
                                                                      ),
                                                                  },
                                                                }),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                            ]
                                          : undefined
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "repairFee",
                                  label: _vm.$t("equipmentFee.detailInfo"),
                                  "min-width": "4%",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-link",
                                            {
                                              staticStyle: {
                                                "font-size": "12px",
                                              },
                                              attrs: { type: "primary" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handle(scope.row)
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "equipmentFee.detailInfo"
                                                    )
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1271653544
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.showApply
                        ? _c(
                            "div",
                            [
                              _c("h4", [
                                _vm._v(_vm._s(_vm.$t("equipmentFee.process"))),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: _vm.applyData,
                                    border: "",
                                    size: "small",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: { type: "index", width: "40" },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "applyType",
                                      label: _vm.$t("equipmentFee.applyType"),
                                      "min-width": "12%",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.ApplyOptions[
                                                      scope.row.applyType
                                                    ]
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3752284595
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "blNo",
                                      label: _vm.$t("equipmentFee.blNo"),
                                      "min-width": "12%",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "containerNo",
                                      label: _vm.$t("equipmentFee.containerNo"),
                                      "min-width": "10%",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "applyFee",
                                      label: _vm.$t("equipmentFee.applyFee"),
                                      "min-width": "10%",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "applyDate",
                                      label: _vm.$t("equipmentFee.applyDate"),
                                      "min-width": "10%",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "status",
                                      label: _vm.$t("equipmentFee.state"),
                                      "min-width": "10%",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.StatusOptions[
                                                      scope.row.status
                                                    ]
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2208050539
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("equipmentFee.chargeFee"),
                        name: "chargeFee",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { "text-align": "center" } },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.chargeData,
                                "row-class-name": _vm.tableRowClassName,
                                border: "",
                                "show-summary": "",
                                "summary-method": _vm.getChargeSummaries,
                                size: "small",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: { type: "index", width: "40" },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "containerNo",
                                  label: _vm.$t("equipmentFee.containerNo"),
                                  width: "110",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "containerType",
                                  label: _vm.$t("equipmentFee.containerType"),
                                  width: "60",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "portName",
                                  label: _vm.$t("equipmentFee.port"),
                                  width: "100",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "startMoveDate",
                                  label: _vm.$t("equipmentFee.startDate"),
                                  width: "100",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "endMoveDate",
                                  label: _vm.$t("equipmentFee.endDate1"),
                                  width: "105",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "days",
                                  label: _vm.$t("equipmentFee.days"),
                                  width: "90",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "actFreeDays",
                                  label: _vm.$t("equipmentFee.freeDays"),
                                  width: "80",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "overDays",
                                  label: _vm.$t("equipmentFee.overDays"),
                                  width: "100",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "rate",
                                  label: _vm.$t("equipmentFee.rate"),
                                  width: "80",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "realTargetFee",
                                  label: _vm.$t("equipmentFee.amount"),
                                  width: "120",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                !_vm.validateNull(
                                                  scope.row.realTargetFee
                                                )
                                                  ? _vm.toMoney(
                                                      scope.row.realTargetFee
                                                    )
                                                  : scope.row.realTargetFee
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1798493538
                                ),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "invoiceAmout",
                                  label: _vm.$t("equipmentFee.invoiceAmout"),
                                  width: "140",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                !_vm.validateNull(
                                                  scope.row.invoiceAmout
                                                )
                                                  ? _vm.toMoney(
                                                      scope.row.invoiceAmout
                                                    )
                                                  : scope.row.invoiceAmout
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3830650268
                                ),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "realTargetCurrency",
                                  label: _vm.$t("equipmentFee.currency"),
                                  width: "80",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "pickupDate",
                                  label: _vm.$t("equipmentFee.pickupDate"),
                                  width: "105",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: { width: "70%", visible: _vm.dialogTableVisible },
                  on: {
                    "update:visible": function ($event) {
                      _vm.dialogTableVisible = $event
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticStyle: { "margin-top": "15px" } },
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.detailInfo,
                            "show-summary": "",
                            "summary-method": _vm.getDetailSummaries,
                            border: "",
                            stripe: "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { type: "index", "min-width": "5%" },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("equipmentFee.componentCode"),
                              prop: "componentCode",
                              "min-width": "35%",
                              "show-overflow-tooltip": true,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.isCnLang
                                              ? scope.row.componentCodeCn
                                              : scope.row.componentCode
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1454794630
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("equipmentFee.repairLocationCode"),
                              prop: "repairLocationCode",
                              "min-width": "25%",
                              "show-overflow-tooltip": true,
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("equipmentFee.damageCode"),
                              prop: "damageCode",
                              "min-width": "25%",
                              "show-overflow-tooltip": true,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.isCnLang
                                              ? scope.row.damageCodeCn
                                              : scope.row.damageCode
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3775720358
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("equipmentFee.repairCode"),
                              prop: "repairCode",
                              "min-width": "25%",
                              "show-overflow-tooltip": true,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.isCnLang
                                              ? scope.row.repairCodeCn
                                              : scope.row.repairCode
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2325052198
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("equipmentFee.amount"),
                              prop: "receiveAccount",
                              "min-width": "12%",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.toMoney(
                                              scope.row.receiveAccount
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              248544061
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("equipmentFee.currency"),
                              prop: "currency",
                              "min-width": "12%",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: { width: "70%", visible: _vm.dialogFtVisible },
                  on: {
                    "update:visible": function ($event) {
                      _vm.dialogFtVisible = $event
                    },
                  },
                },
                [
                  _vm.freeTimeType === 0
                    ? _c(
                        "div",
                        [
                          _c("h4", [
                            _vm._v(
                              "Free Time " +
                                _vm._s(_vm.$t("equipmentFee.effectiveDate"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.detailLongInfo,
                                border: "",
                                stripe: "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: { type: "index", "min-width": "5%" },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t("equipmentFee.ftNo"),
                                  prop: "approvedNo",
                                  "min-width": "35%",
                                  "show-overflow-tooltip": true,
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t("equipmentFee.effectiveDate"),
                                  prop: "effectiveDate",
                                  "min-width": "45%",
                                  "show-overflow-tooltip": true,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.dateFormat(
                                                  "YYYY-MM-DD",
                                                  scope.row.effectiveDate
                                                )
                                              ) +
                                              " ~ " +
                                              _vm._s(
                                                _vm.dateFormat(
                                                  "YYYY-MM-DD",
                                                  scope.row.expireDate
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3983533872
                                ),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t("equipmentFee.demuFreeDays"),
                                  prop: "demuFreeDays",
                                  "min-width": "35%",
                                  "show-overflow-tooltip": true,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(scope.row.demuFreeDays) +
                                              _vm._s(
                                                scope.row.demurrageType === 1
                                                  ? "/(" +
                                                      scope.row.demuRebate +
                                                      "% discount off)"
                                                  : ""
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1191457879
                                ),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t("equipmentFee.detenFreeDays"),
                                  prop: "detenFreeDays",
                                  "min-width": "35%",
                                  "show-overflow-tooltip": true,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(scope.row.detenFreeDays) +
                                              _vm._s(
                                                scope.row.detentionType === 1
                                                  ? "/(" +
                                                      scope.row.detenRebate +
                                                      "% discount off)"
                                                  : ""
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  697044047
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.freeTimeType === 1
                    ? _c(
                        "div",
                        [
                          _c("h4", [
                            _vm._v(
                              "Free Time " +
                                _vm._s(_vm.$t("equipmentFee.containerInfo"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.detailSingleInfo,
                                border: "",
                                stripe: "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: { type: "index", "min-width": "5%" },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t("equipmentFee.containerNo"),
                                  prop: "containerNo",
                                  "min-width": "35%",
                                  "show-overflow-tooltip": true,
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t("equipmentFee.containerType"),
                                  prop: "containerType",
                                  "min-width": "35%",
                                  "show-overflow-tooltip": true,
                                },
                              }),
                              _vm._v(" "),
                              _vm.detailLongInfo[0].combine === 1
                                ? _c("el-table-column", {
                                    attrs: {
                                      label: _vm.$t("equipmentFee.freeDays"),
                                      prop: "demuFreeDays",
                                      "min-width": "35%",
                                      "show-overflow-tooltip": true,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.detailLongInfo[0]
                                                      .demuFreeDays +
                                                      _vm.detailLongInfo[0]
                                                        .detenFreeDays
                                                  ) +
                                                  "\n              "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3163644561
                                    ),
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.detailLongInfo[0].combine !== 1
                                ? _c(
                                    "el-table-column",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "equipmentFee.demuFreeDays"
                                        ),
                                        prop: "demuFreeDays",
                                        "min-width": "35%",
                                        "show-overflow-tooltip": true,
                                      },
                                    },
                                    [
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.detailLongInfo[0].demuFreeDays
                                            ) +
                                            _vm._s(
                                              _vm.detailLongInfo[0]
                                                .demurrageType === 1
                                                ? "/(" +
                                                    _vm.detailLongInfo[0]
                                                      .demuRebate +
                                                    "% discount off)"
                                                : ""
                                            ) +
                                            "\n              "
                                        ),
                                      ],
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.detailLongInfo[0].combine !== 1
                                ? _c(
                                    "el-table-column",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "equipmentFee.detenFreeDays"
                                        ),
                                        prop: "detenFreeDays",
                                        "min-width": "35%",
                                        "show-overflow-tooltip": true,
                                      },
                                    },
                                    [
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.detailLongInfo[0]
                                                .detenFreeDays
                                            ) +
                                            _vm._s(
                                              _vm.detailLongInfo[0]
                                                .detentionType === 1
                                                ? "/(" +
                                                    _vm.detailLongInfo[0]
                                                      .detenRebate +
                                                    "% discount off)"
                                                : ""
                                            ) +
                                            "\n              "
                                        ),
                                      ],
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { span: 11 } }, [
                        _c("div", [
                          _vm.detailType.includes(2)
                            ? _c(
                                "div",
                                [
                                  _c("h4", [
                                    _vm._v(
                                      "Demurrage " +
                                        _vm._s(
                                          _vm.$t("equipmentFee.fixedCosts")
                                        )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-table",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        data: _vm.detailType2,
                                        border: "",
                                        stripe: "",
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          type: "index",
                                          "min-width": "5%",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: _vm.$t(
                                            "equipmentFee.containerType"
                                          ),
                                          prop: "containerType",
                                          "min-width": "35%",
                                          "show-overflow-tooltip": true,
                                          sortable: "",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: _vm.$t(
                                            "equipmentFee.currency"
                                          ),
                                          prop: "currency",
                                          "min-width": "35%",
                                          "show-overflow-tooltip": true,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: _vm.$t("equipmentFee.amount"),
                                          prop: "amount",
                                          "min-width": "35%",
                                          "show-overflow-tooltip": true,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.detailType.includes(0)
                            ? _c(
                                "div",
                                [
                                  _c("h4", [
                                    _vm._v(
                                      "Demurrage " +
                                        _vm._s(
                                          _vm.$t("equipmentFee.chargeByLevel")
                                        )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-table",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        data: _vm.detailType0,
                                        border: "",
                                        stripe: "",
                                        "cell-style": _vm.cellStyle,
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          type: "index",
                                          "min-width": "5%",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: _vm.$t(
                                            "equipmentFee.containerType"
                                          ),
                                          prop: "containerType",
                                          "min-width": "35%",
                                          "show-overflow-tooltip": true,
                                          sortable: "",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: _vm.$t(
                                            "equipmentFee.startDay"
                                          ),
                                          prop: "startDay",
                                          "min-width": "35%",
                                          "show-overflow-tooltip": true,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: _vm.$t("equipmentFee.endDay"),
                                          prop: "endDay",
                                          "min-width": "35%",
                                          "show-overflow-tooltip": true,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: _vm.$t("equipmentFee.amount"),
                                          prop: "amount",
                                          "min-width": "35%",
                                          "show-overflow-tooltip": true,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: _vm.$t(
                                            "equipmentFee.currency"
                                          ),
                                          prop: "currency",
                                          "min-width": "35%",
                                          "show-overflow-tooltip": true,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          attrs: {
                            span: 11,
                            offset:
                              _vm.detailType.includes(0) ||
                              _vm.detailType.includes(2)
                                ? 2
                                : 0,
                          },
                        },
                        [
                          _vm.detailType.includes(4)
                            ? _c(
                                "div",
                                [
                                  _c("h4", [
                                    _vm._v(
                                      "Detention " +
                                        _vm._s(
                                          _vm.$t("equipmentFee.fixedCosts")
                                        )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-table",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        data: _vm.detailType4,
                                        border: "",
                                        stripe: "",
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          type: "index",
                                          "min-width": "5%",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: _vm.$t(
                                            "equipmentFee.containerType"
                                          ),
                                          prop: "containerType",
                                          "min-width": "35%",
                                          "show-overflow-tooltip": true,
                                          sortable: "",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: _vm.$t(
                                            "equipmentFee.currency"
                                          ),
                                          prop: "currency",
                                          "min-width": "35%",
                                          "show-overflow-tooltip": true,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: _vm.$t("equipmentFee.amount"),
                                          prop: "amount",
                                          "min-width": "35%",
                                          "show-overflow-tooltip": true,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.detailType.includes(1)
                            ? _c(
                                "div",
                                [
                                  _c("h4", [
                                    _vm._v(
                                      "Detention " +
                                        _vm._s(
                                          _vm.$t("equipmentFee.chargeByLevel")
                                        )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-table",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        data: _vm.detailType1,
                                        border: "",
                                        stripe: "",
                                        "cell-style": _vm.cellStyle,
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          type: "index",
                                          "min-width": "5%",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: _vm.$t(
                                            "equipmentFee.containerType"
                                          ),
                                          prop: "containerType",
                                          "min-width": "35%",
                                          "show-overflow-tooltip": true,
                                          sortable: "",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: _vm.$t(
                                            "equipmentFee.startDay"
                                          ),
                                          prop: "startDay",
                                          "min-width": "35%",
                                          "show-overflow-tooltip": true,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: _vm.$t("equipmentFee.endDay"),
                                          prop: "endDay",
                                          "min-width": "35%",
                                          "show-overflow-tooltip": true,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: _vm.$t("equipmentFee.amount"),
                                          prop: "amount",
                                          "min-width": "35%",
                                          "show-overflow-tooltip": true,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: _vm.$t(
                                            "equipmentFee.currency"
                                          ),
                                          prop: "currency",
                                          "min-width": "35%",
                                          "show-overflow-tooltip": true,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }